export default __webpack_public_path__ + "static/media/Email.51a98a47.svg";